<template>
	<NoticeDetailPage page-type="auto" :notice-id="noticeId" />
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import NoticeDetailPage from '@/components/notice/NoticeDetailPage.vue';

const route = useRoute();
// 与 PC 端一致：子站详情统一 /{companyId}/notice/{id}.html，类型由详情数据 noticeType 决定（4=头条，否则质量公告）
const noticeId = computed(() => String(route.params.id ?? '').replace(/\.html$/i, ''));
</script>
